document.addEventListener('DOMContentLoaded', function() {
    /*
    * MATERIAS
    */
    // Adiciona a classe 'olho' a todos os blockquotes dentro de .contentOpen
    document.querySelectorAll('.contentOpen blockquote').forEach(el => {
        el.classList.add('olho');
    });

    // Adiciona a classe 'img-caption' ao <p> pai de cada <img> direta em .contentOpen > p
    document.querySelectorAll('.contentOpen > p > img').forEach(img => {
        const parent = img.parentElement;
        if (parent) {
            parent.classList.add('img-caption');
        }
    });
});

document.addEventListener('scroll', function () {
    document.querySelectorAll('.s-content__text mark, .paywall__container mark').forEach(function(mark){
        if ( isInViewport(mark) ) {
            mark.classList.add('highlighted')
        }
    })
    
    const main = document.querySelector('main');

    if (main.classList.contains('hard') || main.classList.contains('soft')) {
        const paragraph = document.querySelector('.s-content__text p:nth-of-type(1)');
        if (paragraph) {
            const pRect = paragraph.getBoundingClientRect();
            const mainRect = main.getBoundingClientRect();
    
            // pega o meio do parágrafo em relação ao main
            const pCenterRelativeToMain = (pRect.top - mainRect.top) + (pRect.height / 2);
    
            const paywall = document.querySelector('.paywall') || document.querySelector('.s-freemium');
            const paywallHeight = paywall ? paywall.offsetHeight : 0;
    
            const maxHeight = pCenterRelativeToMain + paywallHeight;
    
            if (document.body.classList.contains('hide')) {
                main.style.maxHeight = `${maxHeight}px`;
                main.style.overflow = 'hidden';
            } else {
                main.style.maxHeight = '';
                main.style.overflow = '';
            }
        }
    }

    const info = document.querySelector('.info');
    if (info) {
        const imageBlock = Array.from(document.querySelectorAll('.s-content__image')).find(el => window.getComputedStyle(el).display !== 'none');
        const textBlock = document.querySelector('.s-content__text');
        const distance = imageBlock ? imageBlock.offsetTop : (textBlock ? textBlock.offsetTop : 0);

        const header = document.querySelector('.header');
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        
        if (scrollTop > (distance - (header ? header.offsetHeight : 0))) {
            if (info.classList.contains('active')) return;

            info.classList.add('active');

            const banner = document.querySelector('.menu + .banner');
            if (banner && getComputedStyle(banner).position !== 'static') {
                banner.animate([
                    { transform: 'translateY(0px)' },
                    { transform: 'translateY(-100%)' }
                ], {
                    duration: 1000,
                    iterations: 1
                });

                setTimeout(function () {
                    banner.style.position = 'static';
                    const freemium = document.querySelector('.s-freemium');
                    if (freemium) {
                        freemium.classList.add('active');
                    }
                }, 700);
            }
        } else {
            info.classList.remove('active');
        }
    }
});

window.addEventListener('resize', function () {
    const windowSize = window.innerWidth;

    if ( windowSize > 800 ) {
        updateRelatedItemLinks('desktop');
    } else {
        updateRelatedItemLinks('mobile');
    }

    // PUBLIEDITORIAL
    centerImages()
})

// INTERNA
function singleMobilePositions(page, windowWidth) {
    if (!page) return;

    const contentParagraphs = document.querySelectorAll('.contentOpen > p');
    const ssopopular = document.querySelector('.ssopopular--single');

    if (contentParagraphs.length >= 7 && ssopopular) {
        const ssopopularParent = ssopopular.parentElement;

        if (windowWidth < 800) {
            const target = contentParagraphs[6];
            if (target) {
                target.after(ssopopularParent);
            }
        } else {
            const target = document.querySelector('.s-content__grid--second .s-content__left');
            if (target) {
                target.append(ssopopularParent);
            }
        }
    }

    const main = document.querySelector('main');
    if (main?.classList.contains('open')) {
        if (contentParagraphs.length > 3) {
            if (Math.random() >= 0.5) {
                const newsletter = document.querySelector('.s-content__grid--third .h-newsletter');
                const insertAfter = document.querySelector('.s-content__text p:nth-of-type(3)');
                const oldNewsletter = document.querySelector('.s-sign .h-newsletter');

                if (newsletter && insertAfter) {
                    insertAfter.after(newsletter);
                }

                oldNewsletter?.remove();
            } else {
                const join = document.createElement('a');
                join.href = "https://whatsapp.com/channel/0029VaBVuyG23n3ji638N941";
                join.target = "_blank";
                join.title = "Entre no nosso canal do WhatsApp";
                join.className = "s-whatsapp";
                join.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="#25D366" d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z"/></svg><span>Receba, <strong>em primeira mão</strong>, as principais notícias da <strong>CartaCapital</strong> no seu <strong>WhatsApp!</strong></span><div>Inscreva-se</div>`;
                const insertAfter = document.querySelector('.s-content__text p:nth-of-type(3)');
                insertAfter?.after(join);
            }
        }
    }
}

function updateRelatedItemLinks(mode) {
    const items = document.querySelectorAll('.s-content__right .s-related__item');
    items.forEach(item => {
        let href = item.getAttribute('href');
        if (!href) return;

        if (mode === 'desktop') {
            href = href.replace('_inread', '_right').replace('_bottom', '_right');
        } else if (mode === 'mobile') {
            const paragraphCount = document.querySelectorAll('.contentOpen p').length;
            const paragraph = Math.ceil(paragraphCount / 2);
            if (paragraph > 5) {
                href = href.replace('_right', '_inread');
            } else {
                href = href.replace('_right', '_bottom');
            }
        }

        item.setAttribute('href', href);
    });
}

// Center images publieditorial
function centerImages(){
    document.querySelectorAll('.sp-content__text .aligncenter').forEach(el => {
        const imageWidth = el.offsetWidth;
        const container = document.querySelector('.sp-content__text');
    
        if (container) {
            const containerWidth = container.offsetWidth;
        
            if (imageWidth > containerWidth) {
                const diff = imageWidth - containerWidth;
                el.style.transform = `translateX(-${diff / 2}px)`;
            }
        }
    });
};

setupLazySlider('.s-content__text .gallery', $el => {
    $el.find('br').remove();
    $el.slick({
        slidesToShow: 1,
        arrows: false,
        dots: true,
        infinite: false,
        fade: true,
        adaptiveHeight: true,
    });
});

function isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

function setupLazySlider(selector, initCallback, rootMargin = '200px') {
    const elements = document.querySelectorAll(selector);

    if (!elements.length) return;

    const initSlider = el => {
        if (!el.dataset.slickInitialized) {
            const $el = $(el);
            if (typeof $el.slick === 'function') {
                initCallback($el);
                el.dataset.slickInitialized = 'true';
            } else {
                setTimeout(() => initSlider(el), 100);
            }
        }
    };

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                initSlider(entry.target);
                observer.unobserve(entry.target);
            }
        });
    }, { rootMargin });

    elements.forEach(el => {
        if (el.getBoundingClientRect().top < window.innerHeight) {
            initSlider(el);
        } else if ('idle' in window) {
            idle(() => observer.observe(el));
        } else {
            setTimeout(() => observer.observe(el), 200);
        }
    });
}

idle(() => {
    if (window.innerWidth > 800) {
        updateRelatedItemLinks('desktop');
    } else {
        updateRelatedItemLinks('mobile');
    }          

    centerImages()
    singleMobilePositions(document.querySelectorAll('.contentOpen').length, window.innerWidth);
});